export default __webpack_public_path__ + "ee6a8e55972861f351a7870cf4ff33f2.png";